import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { ServiceWithPage } from "../Service.js";
import { servicesCategoriesPathMap, servicesPathMap } from "./servicesPathMap.js";

export function getServiceCategoryPath(service: ServiceWithPage): LocalizedString {
	return Object.values(Locale).reduce<LocalizedString>((acc, locale) => {
		acc[locale] = `${servicesPathMap[locale]}/${servicesCategoriesPathMap[service][locale]}`;
		return acc;
	}, sameValueForEveryLocale(""));
}
